import React, { useEffect, useRef, useState } from 'react'
import "./circleChart.css"
import ApexCharts from "apexcharts";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import useDirection from "../../../hooks/useDirection";


const VisaTypeChart = ({list}) => {
  const chartRef = useRef(null);

  const {t} = useTranslation();
  const dir = useDirection()


  var options = {
    series: [44, 55, 41],
    chart: {
      type: 'donut',
    },
    toolbar: {
      show: false
    },
    events: {
      dataPointMouseEnter: (event) => event.preventDefault() // جلوگیری از اثر هاور
    },
    colors: ["#039DE8" , "#8BD9FF", "#01486B"],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new ApexCharts(document.querySelector(`#chart`), options);
    chartRef.current.render();

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []);

  return (
    <div>
      <div className={"w-full flex justify-between mt-7 mb-5"}>
        <span className={"text-primary-400"}>{t("typeOfVisasObtained")}</span>

      </div>
      <div  className={"flex flex-col md:flex-row items-center justify-between bg-white shadow p-5 rounded-lg"}>
        <div className={"w-full md:w-auto"}>
          <div className={"flex flex-col w-full md:w-[110px] mb-2"}>
            <span className={"text-xs text-gray-600 mt-4 md:mt-2"}>{t('visaOut')}</span>
            <span className={"text-xs text-gray-600 md:my-2 text-end "}>50%</span>
            <div className={"relative h-[10px] rounded-lg bg-gray-200"}>
              <div className={"absolute h-full rounded-lg bg-primary-400 w-[50%]"}/>
            </div>
          </div>
          <div className={"flex flex-col w-full md:w-[110px] mb-2"}>
            <span className={"text-xs text-gray-600 mt-4 md:mt-2"}>{t("visaTree")}</span>
            <span className={"text-xs text-gray-600 md:my-2 text-end "}>70%</span>
            <div className={"relative h-[10px] rounded-lg bg-gray-200"}>
              <div className={"absolute h-full rounded-lg bg-tertiary-600 w-[70%]"}/>
            </div>
          </div>
          <div className={"flex flex-col w-full md:w-[110px] mb-2"}>
            <span className={"text-xs text-gray-600 mt-4 md:mt-2"}>{t("visaTreeStable")}</span>
            <span className={"text-xs text-gray-600 md:my-2 text-end "}>10%</span>
            <div className={"relative h-[10px] rounded-lg bg-gray-200"}>
              <div className={"absolute h-full rounded-lg bg-primary-300 w-[10%]"}/>
            </div>
          </div>
        </div>
        <div className={"flex justify-end relative mt-10 md:mt-0"}>
          <div className={`absolute ${dir ? "top-[24%] left-[38%]" : "top-[27%] left-[35%]"}  md:top-[40%] md:left-[40%] text-lg text-secondary-300 flex flex-col `}>
            <span className={"text-xs text-gray-600 text-center"}>{t("total") }</span>
            <span className={`${dir ? "" : "text-sm"} text-secondary-300`}>{" 321 " + t("visa")}</span>
          </div>
          <div className={"circle_chart_section"} id={`chart`}>
          </div>

        </div>

      </div>
    </div>
  )
}

export default VisaTypeChart;
